module.exports = __webpack_public_path__ + "static/doubleframe-27d259c46a876abf384ddd6f3903f90e.png";